import { CatalogCategoryFilters } from '@/features/catalog-category-filters/ui/CatalogCategoryFilters';

export { CatalogCategoryFilters };
